import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { parseStoryFile, type ParsedStory } from '../utils/parseStoryFile';

const Story: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const [story, setStory] = useState<ParsedStory | null>(null);

  useEffect(() => {
    if (!slug) return;

    const loadStory = async () => {
      try {
        const res = await fetch(`/archive/${slug}.txt`);
        const text = await res.text();

        setStory(parseStoryFile(text, `${slug}.txt`));
      } catch (err) {
        console.error('Error loading story:', err);
      }
    };

    loadStory();
  }, [slug]);

  if (!story) return <div className="p-8">Loading story…</div>;

  return (
  <article className="max-w-3xl mx-auto p-8">
    <h1 className="text-4xl font-bold text-logoPurple mb-2 text-center">
      {story.title}
    </h1>

    <p className="text-sm text-gray-500 mb-6 text-center">
      {story.date}
    </p>

    <img
      src={story.image}
      alt={story.title}
      className="mx-auto w-full max-w-md rounded-lg mb-8"
    />

    <div className="whitespace-pre-wrap text-gray-700 leading-relaxed">
      {story.body}
    </div>
  </article>
);

};

export default Story;
